import React from 'react'
import CheckoutFrame from '../components/CheckoutFrame'
import PropTypes from 'prop-types'
import styles from './test-subscription.scss'
import Button from 'src/components/common/Button'
import cn from 'classnames'
import { userSelector } from 'src/selectors'
import { connect } from 'react-redux'

const plans = [
  {
    id: 1,
    label: 'Essential Monthly no trail (renew every 1 day)',
    url: 'https://buy.stripe.com/test_6oE4k92WIg7IdMc4gJ'
  },
  {
    id: 2,
    label: 'Essential Monthly 1 day trail (renew every 1 day)',
    url: 'https://buy.stripe.com/test_28ocQF68U08K9vWeVo'
  },
  {
    id: 3,
    label: 'Essential Monthly no trail (renew every 7 days)',
    url: 'https://buy.stripe.com/test_6oE5od54Q08K5fG14G'
  },
  {
    id: 4,
    label: 'Essential Monthly 1 day trail (renew every 7 days)',
    url: 'https://buy.stripe.com/test_cN24k940Mf3EbE45kT'
  },
  {
    id: 5,
    label: 'Essential Monthly 4 days trail (renew every 7 days)',
    url: 'https://buy.stripe.com/test_eVaaIxgNy5t40Zq9Ba'
  },
  {
    id: 6,
    label: 'Essential Monthly 4 days trail (renew every month)',
    url: 'https://buy.stripe.com/test_aEUg2RgNy3kW4bCaFf'
  },
  {
    id: 7,
    label: 'Essential Annually no trail (renew every 1 day)',
    url: 'https://buy.stripe.com/test_8wMaIxfJu9JkfUkfZt'
  },
  {
    id: 8,
    label: 'Essential Annually 1 day trail (renew every 1 day)',
    url: 'https://buy.stripe.com/test_6oE7wleFqf3EcI8cNi'
  },
  {
    id: 9,
    label: 'Premium Annually no trail (renew every 1 day)',
    url: 'https://buy.stripe.com/test_8wM3g568UcVw4bC9B7'
  },
  {
    id: 10,
    label: 'Premium Annually 1 day trail (renew every 1 day)',
    url: 'https://buy.stripe.com/test_fZecQF54Q6x88rS3cK'
  }

]

const TestSubscription = (props) => {
  const [selectedPlan, setSelectedPlan] = React.useState(null)
  let href
  if (selectedPlan) {
    href = `${selectedPlan.url}?client_reference_id=${props.user.id}`
  }

  return <CheckoutFrame
    left={<main className={styles['test-main']}>
      <section>
        <h3>Select a test sub:</h3>
        <ul>
          {plans.map((plan, index) => {
            return <li key={index} onClick={() => {
                setSelectedPlan(plan)
              }}>
              <a className={cn({ [styles['active']]: selectedPlan?.id === plan.id })} >{plan.label}</a>
            </li>
            })
          }
        </ul>
      </section>
      <section>
        {href && <a target="_blank" href={href} ><Button>Subscribe</Button></a>}
      </section>
    </main>}
    />
}

const mapStateToProps = (state) => {
  return {
    user: userSelector(state)
  }
}

TestSubscription.propTypes = {
  user: PropTypes.object
}

export default connect(mapStateToProps)(TestSubscription)
